module.exports = __webpack_public_path__ + "assets/img/dzh-31.30f3fae7.jpg";